import React from "react";
import {injectIntl} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import {setDisturbMode} from "store/actions/voiceChat";
import classNames from "classnames/bind";
import {VOICE_CHAT_TYPE} from "utils/constants";
import {showPopUp, TwoBtnPopUp} from "components/PopUp";
import VoiceChatSettingPopUp from "components/PopUp/VoiceChatSettingPopUp";
import micOnIcon from "images/voiceChat/ic_microphone.svg";
import micOffIcon from "images/voiceChat/ic_microphone_off.svg";
import micErrorIcon from "images/voiceChat/ic_microphone_error.svg";
import headsetOnIcon from "images/voiceChat/ic_headset.svg";
import headsetOffIcon from "images/voiceChat/ic_headset_off.svg";
import headsetErrorIcon from "images/voiceChat/ic_headset_error.svg";
import rejectionOnIcon from "images/voiceChat/ic_rejection_on.svg";
import rejectionOffIcon from "images/voiceChat/ic_rejection.svg";
import settingIcon from "images/voiceChat/ic_setting.svg";
import styles from "./index.module.scss";

const Footer = ({
  intl,
  miniMode,
  voiceChatType,
  currentChatMode,
  onClickEnterChat,
  onClickLeaveChat,
  getDevices,
  switchDevice,
  getVolume,
  setVolume,
  micTestStart,
  micTestStop,
  speakerTestStart,
  speakerTestStop,
  audioStatus,
  micStatus,
  setMuted,
  setStatus,
  privateChatStatus,
}) => {
  const cn = classNames.bind(styles);
  const dispatch = useDispatch();
  const disturbMode = useSelector(({voiceChat}) => voiceChat.disturbMode);

  const onClickSetting = () => {
    showPopUp(
      <VoiceChatSettingPopUp
        getDevices={getDevices}
        switchDevice={switchDevice}
        getVolume={getVolume}
        setVolume={setVolume}
        micTestStart={micTestStart}
        micTestStop={micTestStop}
        speakerTestStart={speakerTestStart}
        speakerTestStop={speakerTestStop}
      />,
      {
        defaultPadding: false,
      },
    );
  };

  const onClickBtn = type => {
    if (type === VOICE_CHAT_TYPE[0]) {
      if (currentChatMode === VOICE_CHAT_TYPE[0]) {
        onClickLeaveChat();
      } else if (currentChatMode === VOICE_CHAT_TYPE[1]) {
        showPopUp(
          <TwoBtnPopUp
            title={intl.formatMessage({id: "ID_VOICE_CHAT_WORLD_CHAT_ENTER"})}
            confirmAction={() => {
              setStatus("cancel");
              onClickEnterChat(VOICE_CHAT_TYPE[0]);
            }}
          />,
          {defaultPadding: false},
        );
      } else {
        onClickEnterChat(VOICE_CHAT_TYPE[0]);
      }
    } else if (currentChatMode === VOICE_CHAT_TYPE[1]) {
      showPopUp(
        <TwoBtnPopUp
          title={intl.formatMessage({id: "ID_VOICE_CHAT_WORLD_CHAT_ENTER"})}
          confirmAction={() => {
            setStatus("cancel");
            onClickEnterChat(VOICE_CHAT_TYPE[0]);
          }}
        />,
        {defaultPadding: false},
      );
    }
  };

  const onClickDeviceBtn = type => {
    if (type === "mic") {
      if (micStatus === "error") return;
      setMuted(type);
    }
    if (type === "speaker") {
      if (audioStatus === "error") return;
      setMuted(type);
    }
    if (type === "reject") {
      dispatch(setDisturbMode());
    }
  };

  const getImgSrc = type => {
    if (type === "mic") {
      if (micStatus === "on") return micOnIcon;
      if (micStatus === "off") return micOffIcon;
      return micErrorIcon;
    }
    if (type === "speaker") {
      if (audioStatus === "on") return headsetOnIcon;
      if (audioStatus === "off") return headsetOffIcon;
      return headsetErrorIcon;
    }
  };

  return (
    <div className={cn("voice_chat_footer", miniMode && "mini_mode")}>
      <ul>
        <li
          className={cn(currentChatMode === voiceChatType && "show")}
          onClick={() => onClickDeviceBtn("mic")}
        >
          <img src={getImgSrc("mic")} alt="mic control" />
        </li>
        <li
          className={cn(currentChatMode === voiceChatType && "show")}
          onClick={() => onClickDeviceBtn("speaker")}
        >
          <img src={getImgSrc("speaker")} alt="headset control" />
        </li>
        <li className={cn("show")} onClick={() => onClickDeviceBtn("reject")}>
          <img
            src={disturbMode ? rejectionOnIcon : rejectionOffIcon}
            alt="rejection control"
          />
        </li>
        <li
          className={cn(currentChatMode === voiceChatType && "show")}
          onClick={onClickSetting}
        >
          <img src={settingIcon} alt="setting control" />
        </li>
      </ul>
      {voiceChatType === VOICE_CHAT_TYPE[0] && (
        <button
          type="button"
          className={cn(
            currentChatMode === VOICE_CHAT_TYPE[0] ? "close" : "enter",
          )}
          onClick={() => onClickBtn(VOICE_CHAT_TYPE[0])}
          onKeyDown={e => e.preventDefault()}
        >
          {currentChatMode === VOICE_CHAT_TYPE[0]
            ? intl.formatMessage({id: "ID_VOICE_CHAT_FOOTER_CLOSE_BTN"})
            : intl.formatMessage({id: "ID_VOICE_CHAT_FOOTER_ENTER_BTN"})}
        </button>
      )}
      {voiceChatType === VOICE_CHAT_TYPE[1] &&
        currentChatMode === VOICE_CHAT_TYPE[1] && (
          <button
            type="button"
            className={cn(
              currentChatMode === VOICE_CHAT_TYPE[1] &&
                privateChatStatus === "meeting"
                ? "close"
                : "enter",
            )}
            onClick={() => onClickBtn(VOICE_CHAT_TYPE[1])}
            onKeyDown={e => e.preventDefault()}
          >
            {intl.formatMessage({id: "ID_VOICE_CHAT_FOOTER_CLOSE_BTN"})}
          </button>
        )}
    </div>
  );
};

export default injectIntl(Footer);
